export interface MessageCategory {
  id: string;
  value: string;
}

export const MESSAGE_CATEGORIES: MessageCategory[] = [
  { id: 'software-development', value: `Software-Entwicklung` },
  { id: 'real-estate', value: `Immobilien` },
  { id: 'photography', value: `Fotografie` },
  { id: 'blitzshare', value: `Blitzshare` },
  { id: 'trump-post-alert', value: `Trump Post Alert` },
  { id: 'other', value: `Sonstige` },
];
